import { z } from 'zod';

export const translationReviewSchema = z.object({
  sourceHash: z.string().min(1).optional(),
  origin: z.enum(['automatic', 'manual', 'unknown']).optional(),
  reviewedHash: z.string().min(1).optional(),
});

export const fieldTranslationMetadataSchema = z.object({
  nl: z.record(z.string(), translationReviewSchema).optional(),
  fr: z.record(z.string(), translationReviewSchema).optional(),
  en: z.record(z.string(), translationReviewSchema).optional(),
});
